<template>
  <InfuseModal v-if="importResponse" :title="t('e_connector.import.modal.importResult.title')" @close="emit('close')">
    <div class="flex max-h-[475px] max-w-[965px] flex-col gap-2 overflow-y-auto px-5">
      <p v-if="importResponse.imported.length" class="text-sm text-neutral-800">
        {{ t('e_connector.import.modal.importResult.description.success', { count: importResponse.imported.length }) }}
      </p>

      <p class="text-sm text-red-800">
        {{ t('e_connector.import.modal.importResult.description.failed', { count: importResponse.failed.length }) }}
      </p>

      <div class="max-h-[200px] overflow-y-auto">
        <FailedImportTable :rows="importResponse.failed" />
      </div>
    </div>

    <template #actions>
      <InfuseButton color="secondary" @click="emit('retry')">
        {{ t('e_connector.common.action.retry') }}
      </InfuseButton>
      <InfuseButton @click="emit('close')">
        {{ t('e_connector.common.action.finish') }}
      </InfuseButton>
    </template>
  </InfuseModal>
</template>

<script setup lang="ts">
import { InfuseButton, InfuseModal } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';
import { ImportChargeStationsResponse } from '@infuse/e-connector/charging-station/domain';
import FailedImportTable from './FailedImportTable.vue';

interface Props {
  importResponse?: ImportChargeStationsResponse;
}

interface Emits {
  (e: 'close'): void;
  (e: 'retry'): void;
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits<Emits>();

const { t } = useI18n();
</script>
